import React, { Component } from 'react';
import '../../App.css';
import '../../styles/app-demo.css';
import cardGraphic from '../../assets/for-employers/FintwistCardArt_Generic.svg';
import AppFooter from './app-footer';

class ManageCards extends Component {

  constructor(props){
    super(props)
    this.state = {
      footerUnderline: 'home'
    }
    this.toggleNewRoute = this.toggleNewRoute.bind(this);
  }

  toggleNewRoute(routeName) {
    this.props.toggleNewRoute(routeName);
  }

  render() {

    return (
      <section>
        <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <i onClick={() => this.props.toggleNewRoute('dashboard')} className="fa fa-angle-left"></i>
            <h2>Card Management</h2>
          </div>
          <div id="card-management" className="mobile-app-dashboard">
            <img src={cardGraphic} alt={''} />
            <div>
              <p>Suspend Card</p>
              <label className="switch">
                <input type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </section>
        <AppFooter {...this.state} toggleNewRoute={this.toggleNewRoute} />
        </div>
      </section>
    );
  }
}

export default ManageCards;
